import {getConfig} from '../config/configProvider';
import {axiosInstance, api} from './api.config';

const config = getConfig();
console.log('env - ', config.deploymentEnv);
console.log('version - ', config.version);

const optionAxios = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getTokenApi = () => {
  return axiosInstance.post(api.tokenUrl, {v: 'v1'}).then(res => {
    if (res.data.Data) return res.data.Data.TOKEN;
    else if (res.data.Error && res.data.Messages.length)
      throw res.data.Messages[0];
  });
};

export const getPurchaseOrder = (PurchId, PurchPin, token) => {
  const params = {
    PurchId,
    PurchPin,
    token,
    type: 'json',
    version: 'V1',
  };
  return axiosInstance.get(api.purchOrderUrl, {params}).then(res => {
    if (res.data.Data) return res.data.Data;
    else if (res.data.Error && res.data.Messages.length)
      throw res.data.Messages[0];
  });
};

export const checkTokenCall = (purchId, token) => {
  const params = {
    purchId,
    token,
    type: 'json',
    version: 'V1',
  };
  return axiosInstance.get(api.areasUrl, {params});
};
